export default __webpack_public_path__ + "4fa676d294a18bf943723a4d4ae69c73.png";